export class EntityService {
  protected readonly resource: string;

  constructor(resource: string) {
    this.resource = resource;
  }
}
